import React from 'react'
import './footer.css';
import fb from '../../assets/images/facebook-1_1facebook (1).png';
import twitter from '../../assets/images/twitter_1twitter.png';
import inta from '../../assets/images/instagram_1instagram.png';
import youtube from '../../assets/images/brand_1brand.png';

const Footer = () => {
    return (
        <div>
            <div className="footer">
                <div id="projects" className="section-3-ctas row">

                    <a href="/make-a-donation" className="col-lg-4 col-12 single-block donate">
                        <h2 className="font-white heading-2">Make a Donation</h2>
                    </a>
                    <a href="/gammadda-volunteering" className="col-lg-4 col-12 single-block volunteer">
                        <h2 className="font-white heading-2">Volunteer With Us</h2>
                    </a>
                    <a href="/gammadda-partners" className="col-lg-4 col-12 single-block partner">
                        <h2 className="font-white heading-2">Partner With Us</h2>
                    </a>

                </div>
                <div className="main-footer">
                    <div className="footer-container container pb-5 ">
                        <div className="section-heading row text-center">
                            <h3 className="col-lg-6 col-12 heading-footer gm--h3">Connect With Us</h3>
                            <div className="col-lg-6 col-12 d-flex justify-content-center">
                                <a href="https://www.facebook.com/GammaddaSL" target="_blank" className="mx-2">
                                    <img width="37" src={fb} alt="ABC" className="font-white" />
                                </a>
                                <a href="https://twitter.com/Gammaddalk" target="_blank" className="mx-2">
                                    <img width="37" src={twitter} alt="ABC" />
                                </a>
                                <a href="https://www.instagram.com/gammaddasl/profilecard/" target="_blank" className="mx-2">
                                    <img width="37" src={inta} alt="ABC" />
                                </a>
                                <a href="https://www.youtube.com/channel/UC7TQtAmh2-rO3ficBsysHuA" target="_blank" className="mx-2">
                                    <img width="37" src={youtube} alt="ABC" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="footer-section">
                        <div className="footer-container container">
                            <div className="section-heading-copy">
                                <a href="about" className="footer-links">Who we are</a> 
                                <a href="make-a-donation" className="footer-links">Donate</a>
                                <a href="#" className="footer-links">Gammadda Universe</a>
                                <a href="reach-out" className="footer-links">Reach out</a>
                            </div>
                        </div>
                        <div className="container pb-2">
                            <div className="section-heading row">
                                <div className="col-lg-4 col-12 footer-blurb">Copyright © 2025 MTV Channel (Pvt) Ltd</div>
                                <div className="col-lg-4 col-12 footer-blurb">
                                    <a href="privacy-policy" className="link-2 footer-blurb"> Privacy policy</a>
                                </div>
                                <div className="col-lg-4 col-12 footer-blurb">Designed by Media IT </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer